import { z } from 'zod';

import { PaginationMetaSchema } from './meta.schema';

export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string().optional(),
  time: z.string(),
});

export const ApiDataErrorSchema = z.object({
  isError: z.boolean().optional(),
  errorMessage: z.string().optional(),
});

export const ApiResponseSchema = z.object({
  status: z.number(),
  message: z.string().optional(),
  meta: PaginationMetaSchema.optional(),
});

export type ApiErrorSchemaType = z.infer<typeof ApiErrorSchema>;
export type ApiResponseSchemaType = z.infer<typeof ApiResponseSchema>;
export type ApiDataErrorSchemaType = z.infer<typeof ApiDataErrorSchema>;
